import { Reducer } from 'redux';
import MigrateState from '../state/MigrateState';
import { MigrateAction, MigrateActionTypes } from '../actions/MigrateActions';
import { IAvailableArchitectureType } from '../../models/MigrateModels';

export const initialState: MigrateState = {
  error: '',
  loading: false,
  availableArchitectures: undefined,
};

export const migrateReducers: Reducer<MigrateState> = (state = initialState, action: MigrateAction) => {
  switch (action.type) {
    case MigrateActionTypes.SET_ARCHITECTURES_START:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case MigrateActionTypes.SET_ARCHITECTURES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        availableArchitectures: action.data as IAvailableArchitectureType[]
      };
    case MigrateActionTypes.SET_ARCHITECTURES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data,
      };
    default:
      return state;
  }
};
